import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CoreLanguageService } from '../../services/language.service';
import { KeyValueBase } from '../../shared/models/interface';

@Component({
  selector: 'ya-customselectinput',
  templateUrl: './customSelectInput.component.html',
  styleUrls: ['./customSelectInput.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: CustomSelectInputComponent, multi: true
  }]
})
export class CustomSelectInputComponent implements OnInit, ControlValueAccessor {
  public inputValue: any;
  @Input() inputDataList: KeyValueBase[];
  @Input() inputPlaceholder: string | (() => string);
  @ViewChild("CustomSelectInput", { read: ElementRef }) selectElementRef: ElementRef;

  constructor(private _renderer: Renderer2
    , private _coreLanguageService: CoreLanguageService) { }

  onTouched = () => { };
  onChange = (newValue: any) => { };

  writeValue(value: any): void {
    const me = this;
    if (value && value != 0) {
      me.inputValue = value;
    } else {
      me.inputValue = "";
    }
    me.onChange(me.inputValue);
  }

  registerOnTouched(fn: any) {
    const me = this;
    me.onTouched = fn;
  }

  registerOnChange(fn: any) {
    const me = this;
    me.onChange = fn;
  }

  /**set placeholder for input */
  public setPalceholder() {
    const me = this;
    if (typeof me.inputPlaceholder === "string") {
      return me._coreLanguageService.value(me.inputPlaceholder);
    } else if (typeof me.inputPlaceholder === "function") {
      return me.inputPlaceholder();
    } else {
      return "";
    }
  }

  setDisabledState?(isDisabled: boolean): void {
    const me = this;
    me._renderer.setProperty(this.selectElementRef.nativeElement, 'disabled', isDisabled);
  }

  ngOnInit() {
  }

  public genderSelectionChanged(value: any): void {
    const me = this;
    me.onChange(value);
  }

}
